angular.module('tgaAdmin')
  .service('statsService', ['$http', 'envService',
    function ($http, envService) {
      const serverAddress = envService.read('serverAddress');

      function getLeaderboard(data) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/leaderboard`,
          params: data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getHighScore(gameId, best, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/highscore`,
          params: {
            game_id: gameId,
            best,
            start_date: startDate,
            end_date: endDate,
            hidden: true,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getSessionStats(gameId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/session`,
          params: {
            game_id: gameId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getQuestionStats(gameId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}question/stats`,
          params: {
            game_id: gameId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getAnswerStats(questionId, startDate, endDate, sessionGroupId = null) {
        return $http({
          method: 'GET',
          url: `${serverAddress}question/results/${questionId}`,
          params: {
            start_date: startDate,
            end_date: endDate,
            extended: true,
            session_group_id: sessionGroupId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getGlobalGameStats(startDate, endDate, hubId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/games/global`,
          params: {
            start_date: startDate,
            end_date: endDate,
            hub_id: hubId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getOverviewChart(gameId, startDate, endDate, hubId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/chart/overview`,
          params: {
            game_id: gameId,
            start_date: startDate,
            end_date: endDate,
            hub_id: hubId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getGamesByYear() {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/games/year`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getArcadeStats(data) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/arcade`,
          params: data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getTopCharts(data) {
        return $http({
          method: 'GET',
          url: `${serverAddress}stats/arcade/top`,
          params: data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getLeaderboard,
        getHighScore,
        getQuestionStats,
        getAnswerStats,
        getSessionStats,
        getGlobalGameStats,
        getOverviewChart,
        getGamesByYear,
        getArcadeStats,
        getTopCharts,
      });
    }]);
